/**
 * Direction constants for due term validation.
 */
export const ON_OR_BEFORE = "must-be-on-or-before";
export const ON_OR_AFTER = "must-be-on-or-after";

/**
 * Validates due term hierarchy: measure <= section <= plan.
 * Same term is valid at each level.
 */
export const validateDueTerm = (
  selectedTermId,
  constraintTermId,
  insightsTerms,
  direction
) => {
  if (!selectedTermId || !constraintTermId) return null;

  const selectedTerm = insightsTerms.find((t) => t.id === selectedTermId);
  const constraintTerm = insightsTerms.find((t) => t.id === constraintTermId);

  if (!selectedTerm?.end_at || !constraintTerm?.end_at) return null;

  const selectedEnd = new Date(selectedTerm.end_at);
  const constraintEnd = new Date(constraintTerm.end_at);

  if (direction === ON_OR_BEFORE) {
    if (selectedEnd > constraintEnd) {
      return `This term ends after "${constraintTerm.name}". Choose the same or an earlier term.`;
    }
  } else if (direction === ON_OR_AFTER) {
    if (selectedEnd < constraintEnd) {
      return `This term ends before "${constraintTerm.name}". Choose the same or a later term.`;
    }
  }

  return null;
};
